import { animate, state, style, transition, trigger } from '@angular/animations';

export const supportChatFilters = trigger('supportChatFilters', [
  state('void', style({ height: '0', opacity: 0, overflow: 'hidden' })),
  state('*', style({ height: '*', opacity: 1, overflow: 'hidden' })),
  transition(':enter', [style({ height: '0', opacity: 0 }), animate('200ms ease-out')]),
  transition(':leave', [animate('200ms ease-in', style({ height: '0', opacity: 0 }))]),
]);
